import { useSetAtom } from 'jotai';
import { LucideChevronRight, LucideHash, LucideTruck } from 'lucide-react';

import { $location } from '../../../../shared/state/location.state';
import { RenderMode } from '../../../assistant/_components/chat/entity-reference/types';

interface TruckData {
  id: string;
  licensePlate: string;
  model?: string;
  status?: string;
  transportationType?: string;
}

interface TruckReferenceProps extends TruckData {
  mode: RenderMode | string;
}

export function TruckReference({
  mode,
  id: _id,
  licensePlate,
  model,
  status,
  transportationType,
}: TruckReferenceProps) {
  const setLocation = useSetAtom($location);

  const handleClick = () => {
    setLocation({ pathname: `/facilities/management` });
  };

  if (mode === RenderMode.CARD || mode === 'card') {
    return (
      <span
        className="group my-1 inline-flex max-w-sm min-w-[280px] cursor-pointer items-center gap-3 rounded-lg border border-neutral/20 bg-white px-3 py-2.5 transition-all hover:border-primary/30 hover:shadow-md"
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <span className="flex-1">
          <span className="block text-base font-semibold text-neutral">
            {licensePlate}
          </span>
          {model && (
            <span className="mt-0.5 block text-sm text-neutral/60">
              {model}
            </span>
          )}
          {(transportationType || status) && (
            <span className="mt-1 flex items-center gap-1 text-xs text-neutral/50">
              {transportationType && (
                <span className="flex items-center gap-1">
                  <LucideTruck className="h-3.5 w-3.5" />
                  {transportationType}
                </span>
              )}
              {transportationType && status && (
                <span className="mx-0.5">&middot;</span>
              )}
              {status && (
                <span className="flex items-center gap-1">
                  <LucideHash className="h-3.5 w-3.5" />
                  {status}
                </span>
              )}
            </span>
          )}
        </span>
        <LucideChevronRight className="h-5 w-5 shrink-0 text-neutral/40 transition-colors group-hover:text-primary" />
      </span>
    );
  }

  if (mode === RenderMode.LINK || mode === 'link') {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-1 font-medium text-primary hover:text-primary-darker hover:underline"
      >
        <span>{licensePlate}</span>
      </button>
    );
  }

  return null;
}
